/* Homepage hero photos: hover magnifier (desktop mouse only, off for reduced motion). */
(function () {
  if (!window.matchMedia) return;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function enabled() { return finePointer.matches && !reducedMotion.matches; }

  function init(frame) {
    if (frame.dataset.heroZoomReady) return;
    frame.dataset.heroZoomReady = 'true';
    var img = frame.querySelector('img');
    if (!img) return;

    function move(event) {
      if (!frame.classList.contains('is-zooming')) return;
      var rect = frame.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
    }
    frame.addEventListener('mouseenter', function (event) {
      if (!enabled()) return;
      frame.classList.add('is-zooming');
      move(event);
    });
    frame.addEventListener('mousemove', move);
    frame.addEventListener('mouseleave', function () {
      frame.classList.remove('is-zooming');
    });
  }

  function initAll() {
    document.querySelectorAll('[data-hero-zoom]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
